
import Hero from "@/components/Hero";
import ContactForm from "@/components/ContactForm";
import { Instagram, Linkedin, Mail, MapPin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Võta minuga ühendust"
        bgColor="bg-gradient-to-r from-kaija-light to-kaija-sage"
        buttonText=""
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-medium mb-4">KOOSTÖÖ</h2>
              <div className="w-20 h-1 bg-kaija-slate rounded-full mb-8"></div>
              <p className="text-gray-700 mb-8 text-lg leading-relaxed">
                Broneeri tasuta 20-minutiline tutvutmiskõne, küsi
                koolituspakkumist või kirjuta oma koostöösoovist.
              </p>
              
              <div className="rounded-lg overflow-hidden">
                <ContactForm />
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-sage to-kaija-light/70 p-8 rounded-lg shadow-sm">
              <h2 className="text-2xl font-medium mb-4">Kontaktandmed</h2>
              <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mb-8"></div>
              
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="bg-white/80 w-12 h-12 rounded-full flex items-center justify-center text-kaija-slate mr-4 mt-1 shadow-sm">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-2 text-lg">Elevoria OÜ</h3>
                    <p className="text-gray-700 leading-relaxed">Registrikood: 17129519</p>
                    <p className="text-gray-700 leading-relaxed">Aadress: Tiskre küla, Harku vald, Harjumaa</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-white/80 w-12 h-12 rounded-full flex items-center justify-center text-kaija-slate mr-4 mt-1 shadow-sm">
                    <Mail size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-2 text-lg">E-post</h3>
                    <p className="text-gray-700">
                      <a href="mailto:kaija@kaijaalliksaar.ee" className="hover:text-kaija-slate transition-colors">
                        kaija@kaijaalliksaar.ee
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="pt-4">
                  <h3 className="font-medium mb-4 text-lg">Sotsiaalmeedia</h3>
                  <div className="w-12 h-1 bg-kaija-slate/40 rounded-full mb-6"></div>
                  <div className="flex space-x-4">
                    <a 
                      href="https://www.instagram.com/kaijaalliksaarcoaching/" 
                      target="_blank" 
                      rel="noreferrer" 
                      className="bg-white/80 p-4 rounded-full text-kaija-slate hover:bg-kaija-slate hover:text-white transition-all shadow-sm"
                    >
                      <Instagram size={24} />
                    </a>
                    <a 
                      href="https://www.linkedin.com/in/kaija-alliksaar-a9019557/" 
                      target="_blank" 
                      rel="noreferrer" 
                      className="bg-white/80 p-4 rounded-full text-kaija-slate hover:bg-kaija-slate hover:text-white transition-all shadow-sm"
                    >
                      <Linkedin size={24} />
                    </a>
                    <a 
                      href="https://www.facebook.com/kaija.alliksaar" 
                      target="_blank" 
                      rel="noreferrer" 
                      className="bg-white/80 p-4 rounded-full text-kaija-slate hover:bg-kaija-slate hover:text-white transition-all shadow-sm"
                    >
                      <Facebook size={24} />
                    </a>
                  </div>
                </div>
                
                <div className="pt-6">
                  <h3 className="font-medium mb-4 text-lg">Õiguslik teave</h3>
                  <div className="w-12 h-1 bg-kaija-slate/40 rounded-full mb-6"></div>
                  <div className="space-y-4">
                    <Link 
                      to="/terms" 
                      className="flex items-center bg-white/80 p-4 rounded-lg hover:bg-white transition-all shadow-sm group"
                    >
                      <span className="text-kaija-slate group-hover:translate-x-1 transition-transform">Müügitingimused</span>
                    </Link>
                    <Link 
                      to="/privacy" 
                      className="flex items-center bg-white/80 p-4 rounded-lg hover:bg-white transition-all shadow-sm group"
                    >
                      <span className="text-kaija-slate group-hover:translate-x-1 transition-transform">Privaatsuspoliitika</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
